import { render, staticRenderFns } from "./FilesUpload.vue?vue&type=template&id=ad7a123c&scoped=true"
import script from "./FilesUpload.vue?vue&type=script&lang=js"
export * from "./FilesUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7a123c",
  null
  
)

export default component.exports